import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const RemnantsSectionNav: React.FC = () => (
  <Nav variant="tabs" style={{ marginTop: 16 }} className="mb-3">
    <Nav.Item>
      <Nav.Link as={NavLink} to="/remnants" end>
        Обзор
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/remnants/manage">
        Управление FBS
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as={NavLink} to="/remnants/fbs-orders">
        FBS заказы
      </Nav.Link>
    </Nav.Item>
  </Nav>
);

export default RemnantsSectionNav;
